import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import LandingPage from './pages/LandingPage';
import FinancialReporting from './LandingpageHooks/ResearchPillarHooks/FinancialReporting';
import SolvencyCapital from './LandingpageHooks/ResearchPillarHooks/SolvencyCapital';
import MortalityMorbidity from './LandingpageHooks/ResearchPillarHooks/MortalityMorbidity';
import AssetLiability from './LandingpageHooks/ResearchPillarHooks/AssetLiability';
import InnovationRisk from './LandingpageHooks/ResearchPillarHooks/InnovationRisk';
import Usecursor from './LandingpageHooks/Usecursor';
import PrivacyPolicy from './Policies/PrivacyPolicy';
import TermsofUse from './Policies/TermsofUse';
import DataUsagePolicy from './Policies/DataUsagePolicy';
import ValuationEngine from './ValuationEngine/ValuationEngine';

// Contact
import Contact from './Contact/Contact';

// Research Papers
import Whitepapers from './ResearchPapers/Whitepapers';
import ActuarialInsightBriefs from './ResearchPapers/ActuarialInsightBriefs';
import IndustryCommentaryReports from './ResearchPapers/IndustryCommentaryReports';
import ConferencePapers from './ResearchPapers/ConferencePapers';
import TechnicalNotes from './ResearchPapers/TechnicalNotes';
import PublicDashboards from './ResearchPapers/PublicDashboards';
import RegulatoryResponseSubmissions from './ResearchPapers/RegulatoryResponseSubmissions';

// Blogs
import Blogs from './Blogs/Blogs';
import RiskManagementBlog from './Blogs/BlogHooks/Riskmanagementblog';
import InterestRateRiskBlog from './Blogs/BlogHooks/InterestRateRiskBlog';
import SEOManager from './SEO/SEOManager';

// Games
import Games from './Games/Games';
import BimaPath from './Games/GamesHooks/BimaPath';

// Scroll restoration component
function ScrollRestoration() {
  const { pathname } = useLocation();
  const scrollPositions = useRef({});
  const actionRef = useRef('PUSH');

  useEffect(() => {
    const handlePopState = () => {
      actionRef.current = 'POP';
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    return () => {
      scrollPositions.current[pathname] = window.scrollY;
    };
  }, [pathname]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (actionRef.current === 'POP') {
        const saved = scrollPositions.current[pathname];
        if (saved !== undefined) {
          window.scrollTo(0, saved);
        }
        actionRef.current = 'PUSH';
      } else {
        window.scrollTo(0, 0);
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollRestoration />
      <SEOManager />
      <Usecursor />

      <Routes>
        {/* Main */}
        <Route path="/" element={<LandingPage />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/valuation-engine" element={<ValuationEngine />} />

        {/* Research pillars */}
        <Route path="/research/financial-reporting" element={<FinancialReporting />} />
        <Route path="/research/solvency-capital" element={<SolvencyCapital />} />
        <Route path="/research/mortality-morbidity" element={<MortalityMorbidity />} />
        <Route path="/research/asset-liability" element={<AssetLiability />} />
        <Route path="/research/innovation-risk" element={<InnovationRisk />} />

        {/* Research Papers */}
        <Route path="/research-papers/whitepapers" element={<Whitepapers />} />
        <Route path="/research-papers/actuarial-insight-briefs" element={<ActuarialInsightBriefs />} />
        <Route path="/research-papers/industry-commentary" element={<IndustryCommentaryReports />} />
        <Route path="/research-papers/conference-papers" element={<ConferencePapers />} />
        <Route path="/research-papers/technical-notes" element={<TechnicalNotes />} />
        <Route path="/research-papers/public-dashboards" element={<PublicDashboards />} />
        <Route path="/research-papers/regulatory-responses" element={<RegulatoryResponseSubmissions />} />

        {/* Blogs */}
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/risk-management-money-on-the-table" element={<RiskManagementBlog />} />
        <Route path="/blogs/held-to-maturity-interest-rate-risk" element={<InterestRateRiskBlog />} />

        {/* Games */}
        <Route path="/games" element={<Games />} />
        <Route path="/games/bimapath" element={<BimaPath />} />

        {/* Legal */}
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsofUse />} />
        <Route path="/data-usage" element={<DataUsagePolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
